import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useToast } from "../../contexts/ToastContext";
import AccountDeletionDialog from "../../components/AccountDeletionDialog";
import AlphaSettingWidget from "./AlphaSettingWidget";

export default function AccountDeletionSetting(): React.ReactElement {
  const { user, logout } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return <>
    <AlphaSettingWidget icon={<Trash2 className="h-5 w-5" />} title="Delete account"
      description="Manage deletion of your personal account."
      summary="Close your account" subtext="You will be signed out on every device. Contact an administrator to restore your account."
      actionLabel="Delete account" actionDestructive onAction={() => setOpen(true)} />
    {open && user?.id && <AccountDeletionDialog key={user.id} accountLabel={user.email || "your account"} appearance="alpha" onClose={() => setOpen(false)} onDeleted={async () => {
      await logout();
      toast.success("Your account has been deleted. Contact an administrator if you need it restored.");
      navigate("/", { replace: true });
    }} />}
  </>;
}
